export const shipment = {
    table_data: {},
    product_data: {
        product1: '',
        product2: '',
        product3: '',
        product4: '',
        product5: '',
        product6: '',
        product7: '',
        product8: '',
    },
    is_table_loading: false,
    test: {},
    report_header: '',
    report_name: '',


    shipment_data: null,
    petco_shipment_data: {},
    s3_list: {},
    fileB64: {}
}


// WEBPACK FOOTER //
// ./src/reducers/shipment/shipment.state.js